export const DEFAULT_NOTIFICATIONS_LIMIT = 20;
export const NEW_NOTIFICATIONS_LIMIT = 100;

export type NotificationListStatus = "all" | "unread";

export interface IEmployeeNotification {
  _id: string,
  recipient: string,
  type: string,
  title: string,
  body: string,
  payload?: Record<string, string | number | boolean | null>,
  readAt?: string | null,
  createdAt: string,
  updatedAt: string,
}

export interface IUnreadNotificationsCount {
  count: number,
}

export interface IGetNotificationsRequest {
  page?: number,
  limit?: number,
  status?: NotificationListStatus,
}

export const notificationDocumentPath = (notification: IEmployeeNotification) => {
  const documentId = notification.payload?.consentDocumentId;
  if (typeof documentId !== "string" || !documentId) return "";

  const nursingHomeId = notification.payload?.nursingHomeId;
  const query = typeof nursingHomeId === "string" && nursingHomeId
    ? `?nursingHomeId=${encodeURIComponent(nursingHomeId)}`
    : "";

  return `/home/consent-documents/documents/${documentId}${query}`;
};
